'use client';

import { CircleDollarSign, GraduationCap, PackageSearch, Radar } from 'lucide-react';
import type { ReactElement } from 'react';

import { plannedModules, type PlannedModule } from './module-registry';

const icons: Readonly<Record<PlannedModule['icon'], ReactElement>> = {
  'package-search': <PackageSearch size={20} />,
  radar: <Radar size={20} />,
  'circle-dollar-sign': <CircleDollarSign size={20} />,
  'graduation-cap': <GraduationCap size={20} />,
};

export function PlannedModulesSidebar(): ReactElement {
  return <section className="planned-nav-section" aria-labelledby="planned-nav-title">
    <p className="planned-nav-heading" id="planned-nav-title">后续模块</p>
    <div className="planned-nav-list">
      {plannedModules.map((module) => <button className={`planned-nav-item planned-${module.tone}`} type="button" disabled key={module.id}>
        {icons[module.icon]}
        <span>{module.name}</span>
        <small>规划中</small>
      </button>)}
    </div>
  </section>;
}
